import { P2GBox } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { P2GTextField } from '@parcel2go/core-ui';
import { P2GFade } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useMemo, useState } from 'react';
import AlertWithIcon from '../../AlertWithIcon';
import { SmartSendCsvFieldMap } from '../../csv/SmartSendCsvFieldMap';
import { Tagged } from '../../Tagged';
import { P2GSidePanel } from '~/components/sidepanel';

interface props {
  children?: React.ReactNode;
}

export const CsvFieldInfo: React.FC<props> = (props) => {
  const [show, setShow] = useState(false);
  const [search, setSearch] = useState<string>('');

  const items = useMemo(() => {
    return SmartSendCsvFieldMap.map((x) => {
      return { title: x.fields[0], fields: x.fields.slice(1) };
    }).filter((x) => !search || x.fields.find((f) => f.toLowerCase() == search.toLowerCase()));
  }, [search]);

  return (
    <>
      <P2GLink onClick={() => setShow(!show)}>{props.children}</P2GLink>
      <P2GSidePanel open={show} onClose={() => setShow(false)} anchor="right" title="CSV Mapped Fields">
        {show && (
          <Tagged tag="panel-csv-supported-fields">
            <P2GBox>
              <P2GBox p={2} bordered>
                <P2GGrid container spacing={2} direction="column">
                  <P2GGrid item>
                    <P2GTextField
                      fullWidth
                      onChange={(x) => setSearch(x.currentTarget.value)}
                      value={search}
                      id="Will it match?"
                      label="Will it match?"
                    />
                  </P2GGrid>
                  {search && items.length == 0 && (
                    <P2GGrid item>
                      <P2GFade in>
                        <AlertWithIcon>
                          <P2GText>
                            No exact matches for <strong>'{search}'</strong>.
                          </P2GText>
                        </AlertWithIcon>
                      </P2GFade>
                    </P2GGrid>
                  )}
                  {items.map((x) => (
                    <P2GGrid item key={x.title}>
                      <P2GFade in>
                        <>
                          <P2GText variant="h6">{x.title}</P2GText>
                          {x.fields.map((f) => (
                            <P2GText key={f} component="p">
                              {f}
                            </P2GText>
                          ))}
                        </>
                      </P2GFade>
                    </P2GGrid>
                  ))}
                </P2GGrid>
              </P2GBox>
            </P2GBox>
          </Tagged>
        )}
      </P2GSidePanel>
    </>
  );
};
